import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AngularMaterialModule } from '../angular-material.module';
import { BookmarkBarComponent } from './bookmark-bar/bookmark-bar.component';
import { BookmarkNavComponent } from './bookmark-nav/bookmark-nav.component';
import { ContentHostDirective } from './bookmark-nav/content-host.component';
import { LoadingComponent } from './loading/loading.component';
import { MenuNavComponent } from './menu-nav/menu-nav.component';
import { NavBarMenuItemComponent } from './nav-bar-menu-item/nav-bar-menu-item.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { NavUserButtonsComponent } from './nav-user-buttons/nav-user-buttons.component';
import { NavigationRoutingModule } from './navigation-routing.module';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { DefaultThemeComponent } from './themes/default/default.component';
import { NoThemeComponent } from './themes/no-theme/no-theme.component';
import { TopBarComponent } from './top-bar/top-bar.component';

@NgModule({
  declarations: [
    TopBarComponent,
    NavUserButtonsComponent,
    MenuNavComponent,
    NavBarComponent,
    BookmarkNavComponent,
    BookmarkBarComponent,
    NotFoundPageComponent,
    NavBarMenuItemComponent,
    ContentHostDirective,
    DefaultThemeComponent,
    NoThemeComponent,
    LoadingComponent
  ],
  imports: [CommonModule, NavigationRoutingModule, AngularMaterialModule],
  exports: [NotFoundPageComponent, LoadingComponent],
  providers: []
})
export class NavigationModule {}
